var Backbone = require('backbone');
var _ = require('underscore');
var $ = require('jquery');
var Obscura = require('backbone.obscura');
// var toastr = require('toastr');
// const toastr = require('../helpers/toastr-config');
const notifications = require('../helpers/custom-notifications');
var template = require('../templates/manager.jade');
var SubtitleScope = require('../scopes/subtitle');
var STATUSES = SubtitleScope.VARIABLES.STATUSES;
var SubtitleItem = require('./subtitle-item');
var SubtitleEditor = require('./subtitle-editor');
var reader = require('../helpers/reader');
var dispatcher = require('../dispatcher')
var customConfirm = require("../helpers/custom-confirm");
var captionTimeValidator = require("../helpers/caption-time-validator");

require('jquery-resizable');

module.exports = Backbone.View.extend({
	autoRender: true,
	collection: null,
	template: template(),
	selectedSubtitle: [],
	editor: null,
	filteredCollection: null,
	filteredVal: null,
	filteredIndex: 0,
	dragging: false,
	draggingOriginalWidth: 0,

	initialize: function (options) {
		_.extend(this, options);

		_.bindAll(this, 'selectRow', 'splitSubtitle', 'mergeSubtitle', 'deleteSubtitle', 'pullInViewport',
			'undoChanges', 'redoChanges', 'navigateChange', 'addSubtitle', 'italicFont', 'search', 'updateCaptionTimes');

		this.initEventListeners();

		if (this.autoRender)
			this.render();
	},

	initEventListeners: function () {
		var debouncedEdit = _.debounce(_.bind(this.editSubtitle, this));

		dispatcher.subscribe(dispatcher.events.SELECT_SUBTITLE, this.selectRow);
		dispatcher.subscribe(dispatcher.events.SCROLL_TO, this.scrollTo);

		dispatcher.subscribe(dispatcher.events.EDIT_SUBTITLE, debouncedEdit);
		dispatcher.subscribe(dispatcher.events.ADD_SUBTITLE, this.addSubtitle);
		dispatcher.subscribe(dispatcher.events.DELETE_SUBTITLE, this.deleteSubtitle);
		dispatcher.subscribe(dispatcher.events.SPLIT_SUBTITLE, this.splitSubtitle);
		dispatcher.subscribe(dispatcher.events.MERGE_SUBTITLE, this.mergeSubtitle);
		dispatcher.subscribe(dispatcher.events.UNDO_CHANGES, this.undoChanges);
		dispatcher.subscribe(dispatcher.events.REDO_CHANGES, this.redoChanges);

		dispatcher.subscribe(dispatcher.events.ITALIC, this.italicFont);
		dispatcher.subscribe(dispatcher.events.SEARCH, this.search);
		dispatcher.subscribe(dispatcher.events.NAVIGATE_CHANGE, this.navigateChange);

		dispatcher.subscribe(dispatcher.events.PULL_IN_VIEWPORT, this.pullInViewport);
 
		dispatcher.subscribe(dispatcher.events.REQUEST_CAPTION_UPDATE, this.updateCaptionTimes)
	},

	render: function () {
		this.setElement(this.template);

		$(this.$('.header .col.text.original')).resizable({

			handles: 'e, w',
			minWidth: 100,
			maxWidth: 315,
			resize: _.bind(function (e, ui) {
				var $parent = $(e.target).closest('.row');
				var totalWidth = $parent.width() * 0.82;
				var originalWidth = parseFloat(((ui.size.width * 100) / totalWidth).toFixed(2));

				if (originalWidth < 30) originalWidth = 30;
				if (originalWidth > 70) originalWidth = 70;
				this.$('.col.text.original').css({
					width: originalWidth + '%'
				});

				this.$('.col.text.edited').css({
					width: (82 - originalWidth) + '%',
					left: (18 + originalWidth) + '%'
				});
			}, this)
		});

		return this;
	},

	addSubtitlesEls: function () {
		this.collection.each((model) => {
			var el = new SubtitleItem({
				model: model
			});

			this.$('.subtitles').append(el.render().$el);
		})
	},

	selectRow: function (e, isArrow) {
		if (typeof e === 'undefined') {
			this.$('.subtitles .row.selected').removeClass('selected');
			return;
		}
		if ($(e.target).parents('.context-menu').length) return;

		var $this;

		if (_.isNumber(e)) {
			if (e === -1)
				this.$('.subtitles .row.selected').removeClass('selected');
			else
				$this = this.$('.subtitles .row:eq(' + e + ')');

			if (isArrow) {
				var index = (this.editor && this.editor.$el.parent().length) ? $this.index() - 1 : $this.index();
				localStorage.setItem('selected-subtitle', index);
				var model = this.collection.at(index);
				dispatcher.emit(dispatcher.events.PLAY_SUBTITLE, model, 0);
			}
		} else {
			$this = $(e.currentTarget);

			this.filteredIndex = 0;

			var editorIndex = (this.editor && this.editor.$el.parent().length) ? this.editor.$el.index() : 0;
			var selectedIndex = $this.index();
			var index = ((selectedIndex > editorIndex) && editorIndex > 0) ? $this.index() - 1 : $this.index();
			var model = this.collection.at(index);
			localStorage.setItem('selected-subtitle', index);
			dispatcher.emit(dispatcher.events.PLAY_SUBTITLE, model, 0);
		}

		if ($this && $this.hasClass('selected')) return;

		if ($this) $this.addClass('selected');

		if ($this) $this.siblings('.row.subtitle.selected').removeClass('selected');

		this.pullInViewport();
	},

	addSubtitle: function (preinsert) {	
		var $this = this.$('.row.subtitle.selected');
		var selectedSubtitleIndex = $this.index();
		const MINIMUM_VALID_FRAMES = 2;
		
		if (selectedSubtitleIndex == -1) {
			return notifications.error("Please select subtitle before insert a new subtitle.")
		}

		var model = new SubtitleScope.Model();
		var subData, frameEnd, frameStart, currentModel;
		var shouldInsertBefore = typeof preinsert !== 'undefined';

		if (shouldInsertBefore && selectedSubtitleIndex == 0) {
			currentModel = this.collection.at(selectedSubtitleIndex).getCurrentModel();
			if (currentModel.get('frameStart') < MINIMUM_VALID_FRAMES) {
				notifications.error('No sufficient time gap to add the new subtitle');
				return;
			}
			frameEnd = currentModel.get('frameStart') - 1;
			var isNewSubtitleCanBeLongerThanSecond = frameEnd > reader.frameRate;
			if (isNewSubtitleCanBeLongerThanSecond) {
				frameStart = frameEnd - parseInt(reader.frameRate)
			} else {
				frameStart = 0; //Start from begining
			}
			selectedSubtitleIndex = 0;
		 } else {
			currentModel = this.collection.at(selectedSubtitleIndex).getCurrentModel();
			var nextSubtitle = this.collection.at(selectedSubtitleIndex).getNextSubtitle();
			var nextModel = nextSubtitle ? nextSubtitle.getCurrentModel() : null;

			frameStart = currentModel.get('frameEnd') + 1;

			if (nextModel && parseInt(frameStart) + parseInt(reader.frameRate) < nextModel.get('frameStart'))
				frameEnd = parseInt(frameStart) + parseInt(reader.frameRate);
			else if (nextModel)
				frameEnd = nextModel.get('frameStart') - 1;
			else if (!nextModel)
				frameEnd = frameStart + parseInt(reader.frameRate);

			selectedSubtitleIndex += 1;
		} 

		if (frameEnd - frameStart < MINIMUM_VALID_FRAMES) {
			notifications.error('No sufficient time gap to add the new subtitle');
			return;
		}

		var rawCaptionData = {
			frameEnd: frameEnd,
			frameStart: frameStart,
			row1: '',
			row2: '',
			translationId: $('#language').val(),
		};

		var rawCaptionsData = this.collection.models.filter(m => m.get('status') !== STATUSES.DELETED)
			.map(model => model.getCurrentModel().attributes);
		var isOverlappingOtherCaption = captionTimeValidator.isOverlapping(rawCaptionData, rawCaptionsData);
		if (isOverlappingOtherCaption) {
			notifications.error("New caption overlapping other caption");
			return;
		}

		model.setData(rawCaptionData, shouldInsertBefore ? STATUSES.NEW_PREINSERTED : STATUSES.NEW );

		this.collection.add(model, {
			at: selectedSubtitleIndex
		});

		var el = new SubtitleItem({
			model: model
		});

		if (shouldInsertBefore ) {
			$('.subtitles').prepend(el.render().$el);
		}
		else {
			$('.subtitles .row.subtitle').eq(selectedSubtitleIndex - 1).after(el.render().$el);
		}
		
		dispatcher.emit(dispatcher.events.SELECT_SUBTITLE, selectedSubtitleIndex);
		dispatcher.emit(dispatcher.events.EDIT_SUBTITLE);
		dispatcher.emit(dispatcher.events.PLAY_SUBTITLE, model, 0);
	},

	editSubtitle: function () {
		var $this = this.$('.row.subtitle.selected');

		if (this.editor && this.editor.$el.parent().length) return;

		var index = $this.index();

		if ($this.length == 0) {
			notifications.info('Please select a subtitle');
			return;
		}

		var model = this.collection.at(index);

		if (model.get('status') == STATUSES.DELETED) {
			notifications.error("This subtitle is deleted. Please restore it first.")
			return;
		}

		this.editor = new SubtitleEditor({
			model: this.collection.at(index)
		});

		dispatcher.emit(dispatcher.events.DISABLE_KEYBOARD_CONTROLS);

		$this.after(this.editor.$el);

		this.pullInViewport(true);
	},

	updateCaptionTimes: async function (captionIdAndTimes) {
		var collectionItem = this.collection.models.find(collectionItem => collectionItem.id == captionIdAndTimes.id);
		var captionStatus = collectionItem.get('status');
		var isDeletedCaption = captionStatus == STATUSES.DELETED;
		if (isDeletedCaption) {
			notifications.info('Cannot edit caption');
			return;
		}

		var currentModel = collectionItem.getCurrentModel();
		var newCaptionModel = {
			row1: currentModel.get('row1'),
			row2: currentModel.get('row2'),
			italic: currentModel.get('italic'),
			frameStart: captionIdAndTimes.frameStart,
			frameEnd: captionIdAndTimes.frameEnd,
			translationId: collectionItem.get('translationId')
		}
		var newCaptionStatus = captionStatus;
		if (captionStatus !== STATUSES.NEW_PREINSERTED && captionStatus !== STATUSES.NEW) {
			newCaptionStatus = STATUSES.UPDATED;
		}

		try {
			await dispatcher.emit(dispatcher.events.DB_UPDATE_SUBTITLE, {
				item: collectionItem,
				changes: newCaptionModel,
				status: newCaptionStatus
			});
	
			collectionItem.addToStack(newCaptionModel, newCaptionStatus);
	
		} catch(e) {

		}
	},

	deleteSubtitle: function () {
		var conf;
		var $_this = this.$('.row.subtitle.selected');
		var index = $_this.index();

		if ($_this.length == 0) {
			notifications.info('Please select a subtitle');
			return;
		}

		var model = this.collection.at(index);

		if (model.get('status') == STATUSES.DELETED || model.get('status') == STATUSES.NEW) {

			customConfirm("This action will permanently delete this subtitle. \n\nDo you want to continue?", function() {
				// user clicked "ok"
				dispatcher.emit(dispatcher.events.DB_DELETE_PERMANENT_SUBTITLE, model);

				this.collection.remove(model);
				$_this.remove();

				dispatcher.emit(dispatcher.events.UPDATE_SUB);
			}.bind(this));
			return;
		}

		customConfirm("Delete this subtitle?", function() {
			// user clicked "ok"
			dispatcher.emit(dispatcher.events.UPDATE_SUB_DISPLAY, model, true);
			dispatcher.emit(dispatcher.events.DB_DELETE_SUBTITLE, {
				item: model,
				status: STATUSES.DELETED
			});

			model.set('status', STATUSES.DELETED);
			dispatcher.emit(dispatcher.events.UPDATE_SUB);
		});
	},

	scrollTo: function ($target) {
		if (_.isNumber($target)) {
			$target = $('.subtitles .row').eq($target);
		}

		var index = $target.index();

		var $manager = $('.subtitle-manager .manager');
		if (index <= 1) $manager.stop().animate(0, 300);

		var trHeight = $('.subtitles .row').first().height();
		var scrollSize = trHeight * (index - 4);

		$manager.scrollTop(scrollSize);
	},

	splitSubtitle: async function () {
		const MINIMUM_FRAMES_FOR_SPLIT = 12;
		var $this = this.$('.row.subtitle.selected');
		var captionIndex = $this.index();

		if ($this.length == 0) {
			notifications.info('Please select a subtitle');
			return;
		}

		var collectionItem = this.collection.at(captionIndex);
		var sourceCaptionStatus = collectionItem.get('status');
		var isDeletedCaption = sourceCaptionStatus == STATUSES.DELETED;
		if (isDeletedCaption) {
			notifications.info('Cannot edit caption');
			return;
		}

		var currentModel = collectionItem.getCurrentModel();
		var row1 = currentModel.get('row1');
		var row2 = currentModel.get('row2');
		var isContainsTwoRows = row1 && row2;
		if (!isContainsTwoRows) {
			notifications.info("Select another row.");
			return;
		}

		var originalCaptionStartFrame = currentModel.get('frameStart');
		var originalCaptionEndFrame = currentModel.get('frameEnd');
		var origianlCaptionDuration = originalCaptionEndFrame - originalCaptionStartFrame;
		if (origianlCaptionDuration < MINIMUM_FRAMES_FOR_SPLIT) {
			notifications.error("Title is too short to split");
			return;
		}
		var firstCaptionStartFrame = originalCaptionStartFrame;

		var characterTimeLength = (originalCaptionEndFrame - firstCaptionStartFrame) / (row1.length + row2.length);
		var firstCaptionFrameLength = Math.ceil(characterTimeLength * row1.length);

		var firstCaptionEndFrame = parseInt(firstCaptionStartFrame) + parseInt(firstCaptionFrameLength);
		var isItalic = currentModel.get('italic');

		var secondCaptionStartFrame = parseInt(firstCaptionEndFrame) + 1;
		var secondCaptionFrameEnd = originalCaptionEndFrame;
		var translationId = collectionItem.get('translationId');

		var splitedFirstCaption = {
			row1: row1,
			row2: '',
			italic: isItalic,
			frameEnd: firstCaptionEndFrame,
			frameStart: firstCaptionStartFrame
		};

		var splitedSecondCaption = {
			row1: row2,
			row2: '',
			italic: isItalic,
			frameEnd: secondCaptionFrameEnd,
			frameStart: secondCaptionStartFrame,
			translationId: translationId
		};

		var rawCaptionsData = this.collection.models
			.filter(m => m.get('status') !== STATUSES.DELETED)
			.map(model => model.getCurrentModel().attributes)
			.filter(rawCaption => rawCaption.frameStart != originalCaptionStartFrame && rawCaption.frameEnd != originalCaptionEndFrame);

		var isOverlappingOtherCaption = captionTimeValidator.isOverlapping(splitedSecondCaption, rawCaptionsData);
		if (isOverlappingOtherCaption) {
			notifications.error("New caption overlapping other caption");
			return;
		}

		var sourceCaptionNewStatus = sourceCaptionStatus;
		if (sourceCaptionStatus !== STATUSES.NEW_PREINSERTED && sourceCaptionStatus !== STATUSES.NEW) {
			sourceCaptionNewStatus = STATUSES.UPDATED;
		}
		try {
			await dispatcher.emit(dispatcher.events.DB_UPDATE_SUBTITLE, {
				item: collectionItem,
				changes: splitedFirstCaption,
				status: sourceCaptionNewStatus
			});
		}		
		catch(e) {
			return;
		}	 

		collectionItem.addToStack(splitedFirstCaption, sourceCaptionNewStatus);
		
		var newCaptionItem = new SubtitleScope.Model();
		var newCaptionStatus = sourceCaptionNewStatus == STATUSES.NEW_PREINSERTED ? STATUSES.NEW_PREINSERTED : STATUSES.NEW;

		try {
			await dispatcher.emit(dispatcher.events.DB_INSERT_SUBTITLE, {
				item: newCaptionItem,
				changes: splitedSecondCaption,
				status: newCaptionStatus
			});
		}
		catch(e) {
			return;
		}

		newCaptionItem.setData(splitedSecondCaption, STATUSES.NEW, true);
		this.collection.add(newCaptionItem, {
			at: captionIndex + 1
		});

		var newElementItem = new SubtitleItem({
			model: newCaptionItem
		});
		$('.subtitles .row.subtitle').eq(captionIndex).after(newElementItem.render().$el);
		dispatcher.emit(dispatcher.events.UPDATE_SUB);
	},
	mergeSubtitle: async function () {
		var $this = this.$('.row.subtitle.selected');

		if ($this.length != 1) {
			notifications.info('Please select a subtitle');
			return;
		}
		var index = $this.first().index();

		var firstSubtitle = this.collection.at(index);
		if (firstSubtitle.get('status') == STATUSES.DELETED) {
			notifications.error("This subtitle is deleted. Please restore it first");
			return;
		}
		var nextSubtitle = firstSubtitle.getNextSubtitle();

		var firstModel = firstSubtitle.getCurrentModel();
		var secondModel = nextSubtitle.getCurrentModel();

		var firstRow1 = firstModel.get('row1');
		var firstRow2 = firstModel.get('row2');

		var secondRow1 = secondModel.get('row1');
		var secondRow2 = secondModel.get('row2');
		var isItalic = firstModel.get('italic');

		if ((firstRow1 && firstRow2) || (secondRow1 && secondRow2)) {
			notifications.info('Cannot merge these rows');
			return;
		}
		
		var row1 = firstRow1 ? firstRow1 : firstRow2;
		var row2 = secondRow1 ? secondRow1 : secondRow2;

		var newSub = {
			row1: row1,
			row2: row2,
			italic: isItalic,
			frameStart: firstModel.get('frameStart'),
			frameEnd: secondModel.get('frameEnd'),
			translationId: firstSubtitle.get('translationId')
		};
		
		var firstSubtitleNewStatus = firstSubtitle.statusNew() ? firstSubtitle.get('status') : STATUSES.UPDATED;
		
		try {
			await dispatcher.emit(dispatcher.events.DB_DELETE_SUBTITLE, {
				item: nextSubtitle,
				status: STATUSES.DELETED
			});
			await dispatcher.emit(dispatcher.events.DB_UPDATE_SUBTITLE, {
				item: firstSubtitle,
				changes: newSub,
				status: firstSubtitleNewStatus
			});
		} 
		catch(e) {
			return;
		}


		firstSubtitle.addToStack(newSub, firstSubtitleNewStatus);
		nextSubtitle.set('status', STATUSES.DELETED);
		dispatcher.emit(dispatcher.events.UPDATE_SUB);
	},

	undoChanges: function () {
		var $this = this.$('.row.subtitle.selected');
		var index = $this.index();

		if ($this.length == 0) {
			notifications.info('Please select a subtitle');
			return;
		}

		var model = this.collection.at(index);
		model.undo();
	},

	redoChanges: function () {
		var $this = this.$('.row.subtitle.selected');
		var index = $this.index();

		if ($this.length == 0) {
			notifications.info('Please select a subtitle');
			return;
		}

		var model = this.collection.at(index);
		if (!model.redo()) notifications.error("Cannot redo anymore", '', 2000);
	},

	italicFont: async function () {
		var $this = this.$('.row.subtitle.selected');
		var index = $this.index();

		if ($this.length == 0) {
			notifications.info('Please select a subtitle');
			return;
		}

		var model = this.collection.at(index);
		var isDeletedCaption = model.get('status') == 2;
		if (isDeletedCaption) {
			notifications.info("This subtitle is deleted. Please restore it first.");
			return;
		}
		var isItalic = model.getCurrentModel().get('italic');
		var data = _.clone(model.getCurrentModel().attributes);

		data.italic = !isItalic;

		dispatcher.emit(dispatcher.events.UPDATE_SUB_DISPLAY, model, true);

		var newStatus = model.get('status') == STATUSES.DEFAULT ? STATUSES.UPDATED :  model.get('status');
		try {
			await dispatcher.emit(dispatcher.events.DB_UPDATE_SUBTITLE, {
				item: model,
				changes: data,
				force: true,
				status: newStatus
			});
		}
		catch(e) {
			return;
		}

		model.addToStack(data, newStatus);
	},

	search: function (val, dir) {
		var searchTerm = val.toLowerCase();
		var $this = this.$('.row.subtitle.selected');
		var selectedRowIndex = $this.index();

		if (!this.filteredCollection || this.filteredVal !== searchTerm) {
			this.filteredCollection = new Obscura(this.collection);

			this.filteredCollection.filterBy(function (model) {
				var currentModel = model.getCurrentModel();
				var row1Text = currentModel.get('row1').toLowerCase();
				var row2Text = currentModel.get('row2').toLowerCase();

				var isMatch = (row1Text && row1Text.indexOf(searchTerm) !== -1) || (row2Text && row2Text.indexOf(searchTerm) !== -1);
				return isMatch ? model : '';
			});

			this.filteredVal = searchTerm;
			this.filteredIndex = 0;
		}

		if (this.filteredIndex == this.filteredCollection.length && dir > 0) {
			return;
		} else if (this.filteredIndex < 0) {
			this.filteredIndex = 0
		}

		if (this.filteredIndex > 0 && this.filteredIndex <= this.filteredCollection.length) {
			this.filteredIndex += dir;
		}

		var filterFound = -999;


		if (dir == 1) {
			for (var i = 0; i <= this.filteredCollection.length - 1; i++) {
				var model = this.filteredCollection.at(i);
				if (model.getSubtitleIndex() > selectedRowIndex) {
					if (filterFound === -999) {
						this.filteredIndex = i;
						filterFound = 0;
					} else {
						continue;
					}
				}
			}
		}

		if (dir == -1) {
			for (var i = this.filteredCollection.length - 1; i >= 0; i--) {
				var model = this.filteredCollection.at(i);
				if (selectedRowIndex > model.getSubtitleIndex()) {
					if (filterFound === -999) {
						this.filteredIndex = i;
						filterFound = 0;
					} else {
						continue;
					}
				}
			}
		}

		if (filterFound != -999) {
			var position = this.filteredIndex;
			var model = this.filteredCollection.at(position);

			var index = this.collection.indexOf(model);

			if (this.filteredIndex == 0 && dir > 0) {
				this.filteredIndex += dir;
			}

			dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
			dispatcher.emit(dispatcher.events.SELECT_SUBTITLE, index);
			dispatcher.emit(dispatcher.events.SCROLL_TO, index);
			dispatcher.emit(dispatcher.events.UPDATE_SUB_DISPLAY, model, true);
			dispatcher.emit(dispatcher.events.PLAY_SUBTITLE, model, 0);
		} else {
                // Prevent duplicate notification messages
                if (!this.lastNotificationTime || Date.now() - this.lastNotificationTime > 1000) {
                    notifications.info("no more result found for your query", '', 2000);
                    this.lastNotificationTime = Date.now();
                }
		}

	},

	navigateChange: function (dir) {

		var $edits = this.$('.row.subtitle.status-updated,.row.subtitle.status-new,.row.subtitle.status-deleted,.row subtitle status-default, .row.selected');
		var selectedIndex = -1;

		$edits.filter(function (index) {
			var $el = $(this);
			if ($el.hasClass('selected'))
				selectedIndex = index;
		});

		if ($edits.length === 0) {
			alert("There are no edits");
			return;
		}

		if (selectedIndex === -1) {
			selectedIndex = 0;

		} else {
			if (dir === -1) selectedIndex--;
			else selectedIndex++;
		}

		if (selectedIndex >= $edits.length || selectedIndex < 0) selectedIndex = 0;

		var $target = $($edits.get(selectedIndex));
		$target.click();
		this.scrollTo($target);
	},

	pullInViewport: function (forEditor, forOpenedEditor) {
		var elementPosition;
		var editorHeight;
		var $row;

		if (!forOpenedEditor) $row = this.$('.row.subtitle.selected');
		else $row = this.$('.row.subtitle.editing');

		if (!$row || !$row.length) return;

		var rowOffset = $row.offset().top;

		var $manager = this.$('.manager');
		var managerTop = $manager.offset().top;

		var outOfViewport = $manager.height() + managerTop;

		elementPosition = rowOffset + $row.height();

		if (forEditor) {
			editorHeight = this.editor.$el.height();
			elementPosition += editorHeight;
		}

		if (elementPosition >= outOfViewport || elementPosition < managerTop) {
			var scrollSize;

			var index = $row.index();
			var trHeight = $('.subtitles .row').first().height();

			if (forEditor) {
				scrollSize = trHeight * (index - 5) + editorHeight;
			} else {
				scrollSize = trHeight * (index - 5);
			}

			if (localStorage.getItem('jump') == "true") {
				scrollSize = scrollSize + (5 * trHeight);
				localStorage.setItem('jump', false);
			}

			$('.subtitle-manager .manager').scrollTop(scrollSize);
			dispatcher.emit(dispatcher.events.SELECT_SUBTITLE, $row.index());
		}
	}
});


// WEBPACK FOOTER //
// ./app/views/subtitle-manager.js